module.exports = __webpack_public_path__ + "img/public/SiteIcons/supportIconTwo.svg?2a020eab";